import { render, staticRenderFns } from "./EmpresaSelector.vue?vue&type=template&id=283a6e3c"
import script from "./EmpresaSelector.vue?vue&type=script&lang=js"
export * from "./EmpresaSelector.vue?vue&type=script&lang=js"
import style0 from "./EmpresaSelector.vue?vue&type=style&index=0&id=283a6e3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports